import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";
import { TiltCard, CocoaParticles } from "@/components/ChocolateFX";

const Occasion = ({ o, i }) => (
  <section id={o.id} data-testid={`occasion-${o.id}`} className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-14 border-t border-[#3B251D] first:border-t-0">
    <div className={`grid lg:grid-cols-[360px_1fr] gap-10 items-start ${i % 2 ? "lg:[direction:rtl]" : ""}`}>
      <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="[direction:ltr] lg:sticky lg:top-28">
        <TiltCard className="lux-card overflow-hidden" max={8}>
          <img src={o.image} alt={o.title} className="w-full aspect-[4/3] object-cover" />
        </TiltCard>
        <p className="text-[10px] tracking-[0.3em] text-[#D4AF37] mt-6">OCCASION {String(i + 1).padStart(2, "0")}</p>
        <h2 className="font-display text-3xl mt-1">{o.title}</h2>
        <p className="text-[#C8B8AB] text-sm mt-2">{o.description}</p>
        {o.id === "corporate" && (
          <Link to="/customisation" data-testid="guide-corporate-cta" className="inline-flex items-center gap-1 text-[#D4AF37] text-sm mt-4 hover:text-[#F3D8A2]">Request a bulk quote <ArrowRight size={14} /></Link>
        )}
      </motion.div>
      <div className="[direction:ltr] grid grid-cols-2 xl:grid-cols-3 gap-5">
        {o.products.map((p, j) => <ProductCard key={p.product_id} product={p} index={j} />)}
      </div>
    </div>
  </section>
);

export default function GiftingGuide() {
  const [guide, setGuide] = useState([]);
  useEffect(() => { api.get("/gifting-guide").then((r) => setGuide(r.data)); }, []);
  return (
    <div data-testid="gifting-guide-page">
      <section className="relative overflow-hidden bg-[radial-gradient(ellipse_at_30%_20%,#3B251D_0%,#120A07_65%)]">
        <CocoaParticles count={12} />
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-16">
          <span className="eyebrow">Gifting Occasion Guide</span>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl mt-3 max-w-3xl">The right chocolate for every moment</h1>
          <p className="text-[#C8B8AB] mt-5 max-w-2xl">Hand-picked from our sixty creations — from birthdays to boardrooms. Choose a pack size, set the quantity and add straight to your cart.</p>
          <div className="flex flex-wrap gap-2 mt-8" data-testid="guide-occasion-nav">
            {guide.map((o) => (
              <a key={o.id} href={`#${o.id}`} data-testid={`guide-nav-${o.id}`}
                onClick={(e) => { e.preventDefault(); document.getElementById(o.id)?.scrollIntoView({ behavior: "smooth" }); }}
                className="px-4 py-2 rounded-full border border-[#3B251D] text-[#C8B8AB] text-xs hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors">{o.title}</a>
            ))}
          </div>
        </div>
      </section>
      {guide.map((o, i) => <Occasion key={o.id} o={o} i={i} />)}
    </div>
  );
}
